// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useEffect } from "react";

import { getSession } from "../utils/sessionstore";

import { useNavigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = getSession("userDetails");
    // console.log(userDetails,"userDetails from admin route protector")

    if (userDetails?.permissions !== "HWAI_ADMIN") {
      navigate("/");
      return;
    }
  }, []);

  return children;
};

export default memo(AdminRoute);
